import FileModel from './globals/FileModel';

export default class StandImportFile extends FileModel {
  static get path() {
    return '/backend/stand_import_files/{?id}';
  }
}
